import { useEffect } from 'react';
import { createPortal } from 'react-dom';

// Fullscreen modal that renders an internal prototype URL in an iframe.
// Esc closes, body scroll is locked while open.
// Portaled to document.body so ancestor transforms don't trap position:fixed.
export default function PrototypeModal({ url, label, caseTitle, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [onClose]);

  return createPortal(
    <div className="proto-modal" role="dialog" aria-modal="true" aria-label={`${label} prototype`}>
      <div className="proto-modal__chrome">
        <div className="proto-modal__breadcrumb">
          <span className="proto-modal__dot" />
          <span className="proto-modal__label proto-modal__label--full">{caseTitle ? `${caseTitle} prototype` : 'Prototype'}</span>
          <span className="proto-modal__label proto-modal__label--short">{caseTitle || 'Prototype'}</span>
          <span className="proto-modal__sep">/</span>
          <span className="proto-modal__label proto-modal__label--muted">{label}</span>
        </div>
        <div className="proto-modal__actions">
          <a href={url} target="_blank" rel="noopener noreferrer" className="proto-modal__external">
            Open in new tab <span>↗</span>
          </a>
          <button onClick={onClose} className="proto-modal__close" aria-label="Close prototype">
            <span>← Back to portfolio</span>
          </button>
        </div>
      </div>
      <iframe src={url} title={`${label} prototype`} className="proto-modal__iframe" />
    </div>,
    document.body,
  );
}
